var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.props.sortable)?_c('i',{class:_vm.icon,staticStyle:{"margin-left":"0.5rem"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }